/**
 * 路由配置
 */
export default [
    {
        key: 'SIGN_IN',
        title: '登录',
        href: '/',
        exact: true,
        component: 'SSO',
    },
    {
        key: 'SSOErrorPage',
        title: 'SSOErrorPage',
        href: '/sso-error/:errorCode?',
        exact: true,
        component: 'SSOErrorPage',
    },
];
